
// vue
import { defineComponent, computed, reactive } from 'vue';

export default defineComponent({
  name: 'Heading',
  props: {
    level: {
      type: Number,
      required: true,
    },
    fontSize: {
      type: String,
      required: false,
      default: '2x',
    },
    colorCode: {
      type: String,
      required: false,
      default: '#444',
    },
    textAlign: {
      type: String,
      required: false,
      default: 'left',
    },
    isFullWidth: {
      type: Boolean,
      required: false,
    },
  },
  setup(props) {
    const headTag = computed(() => {
      return `h${props.level}`;
    });

    const fzVal = `var(--fz-${props.fontSize})`;
    const styles = reactive({
      'font-size': fzVal,
      color: props.colorCode,
      textAlign: props.textAlign,
      width: 'auto',
    });

    if (props.isFullWidth) {
      styles.width = '100%';
    }
    return {
      headTag,
      styles,
    };
  },
});
